<template>
  <nav-bar :title="dMess.departName" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <div class="department">
      <van-icon name="wap-home-o" />
      <span>{{ dMess.groupName }} </span>
    </div>
    <div class="row-btn">
      <van-row gutter="16">
        <van-col span="12">
          <van-button type="primary" size="small" block plain to ="/newCustomers" >新增开拓客户</van-button>
        </van-col>
      </van-row>
    </div>
    <van-cell-group title="已提交开拓用户列表">
      <van-cell v-for="item in cList" :key="item.userId" :title="item.companyName" :value="item.userStatus" :to="item.userStatus === '待开拓用户' ? `/modCustomer/${item.userId}` : ''">
        <template #extra>
          <van-button class="cell-btn" type="danger" size="small" @click.stop="handleDelClick(item)">删除</van-button>
        </template>
      </van-cell>
    </van-cell-group>
    <Empty v-if="!cList.length" />
  </Content>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { getAgentMesslist } from '@/api/agentMess'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { listExtCustomer, deletetCustom } from '@/api/customer'

export default {
  name: 'ExtCustomerList', // 拓展列表
  props: [],
  setup (prop) {
    const dMess = ref({})
    const cList = ref([])
    const loading = ref(false)
    const finished = ref(false)
    const store = useStore()
    const searchWord = ref('') // 搜索关键词
    const departId = computed(() => store.state.roleInfo.departId)
    // 获取公司信息
    const getAgentMess = async () => {
      const { status, data } = await getAgentMesslist(departId.value)
      if (status === 200) {
        dMess.value = data
      }
    }
    const pa = reactive({
      deptId: departId.value
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(listExtCustomer, (data) => {
      cList.value = data
    }, pa)
    getAgentMess()
    getDataLoading()
    const handleDelClick = ({ userId }) => {
      Dialog.confirm({
        title: '提示',
        message: '删除后无法恢复，是否确认删除？'
      })
        .then(() => {
          // 删除
          Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '请稍后...'
          })
          deletetCustom(userId).then(res => {
            Toast.clear()
            Toast.success('删除成功')
            cList.value = cList.value.filter(item => item.userId !== userId)
          }).catch(() => {
            Toast.clear()
            Toast.fail('删除失败')
          })
        })
        .catch(() => {})
    }
    return {
      getDataLoading,
      isLoading,
      showLoading,
      loading,
      finished,
      cList,
      dMess,
      getAgentMess,
      searchWord,
      pa,
      handleDelClick
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-bottom: 16px;
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
.department {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  padding: 16px;
}
.row-btn {
  margin: 16px;
}
.van-cell {
  align-items: center;
  .cell-btn {
    margin-left: 10px;
  }
}
</style>
